export interface AudioChunk {
    seq: number;
    wav: Blob;
    startTime: number;
    endTime: number;
    sessionId: string;
}
export interface TranscriptEntry {
    seq: number;
    response: string;
    success: boolean;
    processingTime: string;
    wordCount?: number;
    durationSec: number;
    sessionId: string;
}

export type RecordingState = 'idle' | 'recording' | 'paused' | 'stopped';
export type ScribeState = RecordingState;
export type SpeechProvider = 'audio-chunks' | 'azure' | 'ASR';
export type SttUIStatus = 'listening' | 'processing' | '';

export function resolveOverlayStatus(
    provider: SpeechProvider,
    recording: boolean,
    status: SttUIStatus
): SttUIStatus {
    return provider === 'azure' ? (recording ? 'listening' : '') : status;
}